
















// responsible for getting deck & searching
import Vue from 'vue'
import { DeckInfo } from '../../models'
import { getDecks } from '../../assets/utility'
import { firestore } from 'firebase'
import store from '../../store'
export default Vue.extend({
  name: 'Decks',
  mounted () {
    store.commit('setCurrentDeck', '')
    this.getDecks('')
  },
  data () {
    return {
      decks: {} as any,
      keyword: '',
      requests: {} as any,
      requestsResult: {} as any
    }
  },
  watch: {
    decks (newVal, oldVal) {
      // after fetching all decks, make 1 deck a current deck
      // console.log('decks changed', newVal)
      if (Object.keys(newVal).length > 0) {
        store.commit('setCurrentDeck', Object.keys(newVal)[0])
      }
    },
    requestsResult: {
      handler (newVal, oldVal) {
        // console.log('TCL: requestsResult -> newVal', newVal)
        let vm = this
        let keyword = this.keyword.toUpperCase()
        if (keyword in newVal && Object.keys(newVal[keyword]).length > 0) {
          vm.decks = newVal[keyword]
        }
      },
      deep: true
    }
  },
  computed: {
    currentDeck () {
      return store.state.currentDeck
    }
  },
  methods: {
    getDecks (keyword:string) {
      // console.log('TCL: getDecks -> keyword', keyword)
      let vm = this
      vm.decks = {}
      keyword = keyword.toUpperCase()
      if (keyword in this.requestsResult && Object.keys(this.requestsResult[keyword]).length > 0) {
        vm.decks = this.requestsResult[keyword]
        console.log('reverung')
        return
      }
      if (keyword in this.requests) {
        return
      }
      vm.requests[keyword] = 'searching'
      // vm.requestsResult[keyword] = {}
      vm.$set(vm.requestsResult, keyword, {})
      getDecks(keyword)
        .then(function (querySnapshot: firestore.QuerySnapshot) {
          querySnapshot.forEach(function (doc: firestore.QueryDocumentSnapshot) {
            // console.log('TCL: getDecks -> doc', keyword, doc.data())
            let deckInfo = doc.data()
            if (deckInfo.count > 0 && deckInfo.name.toUpperCase().indexOf(keyword) >= 0) {
              vm.$set(vm.requestsResult[keyword], doc.id, doc.data())
            }
          })
        }).catch(function (err:any) {
          console.log(err)
        })
    },
    setCurrentDeck (deckId:string) {
      store.commit('setCurrentDeck', deckId)
    }
  }
})
